<script setup>
import { ref } from 'vue';
import WhatsAppCallDialog from './WhatsAppCallDialog.vue';

const callDialogRef = ref(null);

const present = payload => callDialogRef.value?.openIncoming(payload) || false;

defineExpose({ present });
</script>

<template>
  <WhatsAppCallDialog ref="callDialogRef" />
</template>
